import { faBook, faHouse, faPersonPraying } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import Link from 'next/link';

export default function Layout({ children, className }: any) {
  return (
    <motion.div
      animate={{ opacity: 1 }}
      className={className}
      exit={{ opacity: 0 }}
      initial={{ opacity: 1 }}
      transition={{
        type: 'tween',
        ease: 'easeOut',
        duration: 0.1,
      }}
    >
      {children}
      {false && (
        <div className="md:hidden fixed z-50 h-16 md:max-w-lg w-screen -translate-x-1/2 bg-white border border-gray-200 md:rounded-full md:bottom-4 bottom-0 left-1/2 dark:bg-gray-700 dark:border-gray-600">
          <div className="grid h-full max-w-lg grid-cols-3 mx-auto">
            <button
              className="inline-flex flex-col items-center justify-center px-5 rounded-l-full hover:bg-gray-50 dark:hover:bg-gray-800 group"
              data-tooltip-target="tooltip-home"
              type="button"
            >
              <FontAwesomeIcon icon={faBook} size="2x" style={{ height: '20px' }} />
              <p className="text-xs">Hadith</p>
            </button>
            <div className="flex items-center justify-center">
              <Link
                className="inline-flex items-center justify-center w-10 h-10 font-medium bg-blue-600 rounded-full hover:bg-blue-700 group focus:ring-4 focus:ring-blue-300 click:outline-none dark:focus:ring-blue-800"
                data-tooltip-target="tooltip-new"
                href="/"
                type="button"
              >
                <FontAwesomeIcon icon={faHouse} size="2x" style={{ color: 'white', height: '20px' }} />
              </Link>
            </div>
            <div
              className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
              id="tooltip-new"
              role="tooltip"
            >
              Create new item
              <div data-popper-arrow className="tooltip-arrow"></div>
            </div>
            <button
              className="inline-flex flex-col items-center justify-center px-5 rounded-r-full hover:bg-gray-50 dark:hover:bg-gray-800 group"
              data-tooltip-target="tooltip-home"
              type="button"
            >
              <FontAwesomeIcon icon={faPersonPraying} size="2x" style={{ height: '20px' }} />
              <p className="text-xs">Dua</p>
            </button>
          </div>
        </div>
      )}
    </motion.div>
  );
}
